import styled, { css } from 'styled-components';
import { Btn } from 'components';

export const ContentsWrapper = styled.div`
    margin: 0 auto;
    width: 100%;
    max-width: 940px;
`;

export const TitleContainer = styled.div``;
export const TitleWrapper = styled.div``;

export const CaptionContainer = styled.div`
    margin-top: 28px;
    margin-bottom: 28px;
`;
export const CaptionWrapper = styled.div``;

export const BtnContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 28px;

    @media only screen and (max-width: 340px) {
        flex-direction: column;
        align-items: flex-start;
        ${props => {
        return css`
        ${BtnSignInStyled}{
            width: auto;
            margin-top: 16px;
        }`
    }}
    }
`;

export const BtnWrapper = styled.div`
    width: 160px;
`;

export const BtnSignInStyled = styled(Btn)`
    text-decoration-line: underline;
`;
